"use client"

import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import {
  Box,
  Button,
  Image,
  Text,
  useDisclosure,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  VStack,
} from "@chakra-ui/react"
import { HasAccess } from "../../../../common/utils/accessUtils"
import { getLoggedInUser, getEffectiveRoleName, isEmployee as checkIsEmployee, isSuperAdmin as checkIsSuperAdmin } from "common/utils/roleUtils"
import CommonCheckTable from "common/components/checktable"
import { useLocation, useMatch, useNavigate, useSearchParams } from "react-router-dom"
import CommonDeleteModel from "common/components/commonDeleteModel"
import { toast } from "react-toastify"
import editIcon from "common/assets/img/editIcon.png"
import { constant } from "common/constant"
import { globalStyles } from "common/theme/styles"
import { recruitConstant } from "services/Recruit/constant"
import { InterviewData } from "services/Recruit/data/interviewData"
import deleteIcon from "common/assets/img/deleteIcon.png"
import CustomStatusDropdown from "services/Recruit/components/AvailabilityDropdown"
import { accessModuleTitles } from "common/constant"
import { deleteManyApi } from "common/services/api"
import { getApi } from "common/services/api"
import { formatJobTitle } from "services/Crm/utils/calcUtils"
import { interviewStatusLabels } from "common/constant"
import { putApi } from "common/services/api"
import { API_PATHS } from "common/services/apiPaths"
import { feedbackConstants } from "common/constant"
import { interviewStatusOptions } from "services/Recruit/data/dropdownData"
import { getStatusColor } from "common/utils/statusColor"
import InfoModal from "common/components/infoModel"
import ActionMenu from "common/components/ActionMenu"
import PreviousApplicationInterviewModal from "services/Recruit/components/PreviousInterviewModal"
import CustomStatus from "common/components/status/CustomStatus"
import {
  getTableFilters,
  saveTableFilters,
  clearTableFilters,
  getInitialFilterState
} from "common/utils/filterUtils";

const Interview = ({ customApiEndpoint }) => {
  const title = recruitConstant.createInterView
  const TABLE_NAME = 'interviews'; // Define table name constant
  const [action, setAction] = useState(false)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [edit, setEdit] = useState(false)
  const [eventView, setEventView] = useState(false)
  const [id, setId] = useState("")
  const [selectedId, setSelectedId] = useState()
  const [selectedValues, setSelectedValues] = useState([])
  const [advanceSearch, setAdvanceSearch] = useState(false)
  const [getTagValuesOutSide, setGetTagValuesOutside] = useState([])
  const [searchboxOutside, setSearchboxOutside] = useState("")
  const [deleteModel, setDelete] = useState(false)
  const [isImportLead, setIsImportLead] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])
  const [displaySearchData, setDisplaySearchData] = useState(false)
  const [searchedData, setSearchedData] = useState([])
  const [tableData, setTableData] = useState(InterviewData)
  const colors = globalStyles.colors

  const isInitialMount = useRef(true);

  // Add URL parameter handling - support both regular routing and hash routing
  const [searchParams] = useSearchParams()
  let urlInterviewDate = searchParams.get("interviewDate")

  // Fallback: If not found in searchParams, try parsing from hash (for hash routing)
  if (!urlInterviewDate && window.location.hash) {
    const hashParts = window.location.hash.split("?");
    if (hashParts.length > 1) {
      const hashParams = new URLSearchParams(hashParts[1]);
      urlInterviewDate = hashParams.get("interviewDate");
    }
  }

  // Helper function to format time
  const formatTime = (timeString) => {
    if (!timeString) return "-"
    const date = new Date(timeString)
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }

  const [permission, leadAccess, contactAccess] = HasAccess([accessModuleTitles.Interviews,])
  const [feedbackPermission] = HasAccess([
    accessModuleTitles.Feedback,
  ]);
  const navigate = useNavigate()

  const location = useLocation()
  const state = location.state

  const [currentPage, setCurrentPage] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"))
    return paginationState?.pageName === title && paginationState?.currentPage ? paginationState.currentPage : 1
  })

  const [pageSize, setPageSize] = useState(() => {
    const paginationState = JSON.parse(localStorage.getItem("paginationState"))
    return paginationState?.pageName === title && paginationState?.pageSize ? paginationState.pageSize : 10
  })
  const [sortColumn, setSortColumn] = useState(null) // Track the sorted column
  const [sortOrder, setSortOrder] = useState("")
  const [searchbox, setSearchbox] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.searchbox || null;
  });
  const [currentStatusFilter, setCurrentStatusFilter] = useState(() => {
    const filters = getInitialFilterState(TABLE_NAME);
    return filters?.currentStatusFilter || "";
  });

  // Save filters whenever they change
  useEffect(() => {
    const filters = {
      currentStatusFilter,
      searchbox: searchbox || "",
    };
    saveTableFilters(TABLE_NAME, filters);
  }, [currentStatusFilter, searchbox]);
  const [finalSearchedData, setFinalSearchedData] = useState([])
  const [metadata, setMetadata] = useState({})
  const [menuSelectedDeleteItem, setMenuSelectedDeleteItem] = useState([])
  const loginUserData = JSON.parse(localStorage.getItem("user"));
  const [infoModal, setInfoModal] = useState({ isOpen: false, message: "" });

  const loggedInUser = getLoggedInUser();
  const effectiveRoleName = getEffectiveRoleName(loggedInUser);
  const roleName = effectiveRoleName; // Keep for backward compatibility
  const isEmployee = checkIsEmployee(loggedInUser);
  const isSuperAdmin = checkIsSuperAdmin(loggedInUser);

  const [candidateData, setCandidateData] = useState([])
  const [previousInterviewModal, setPreviousInterviewModal] = useState({
    isOpen: false,
    applicationId: null,
    candidateName: '',
    jobTitle: '',
    currentInterviewId: null,
    currentInterviewDate: null,
    currentRound: null
  })
  useEffect(() => {
    const fetchCandidateData = async (
    ) => {
      let endpoint = `${API_PATHS.CANDIDATE_LIST}?allData=true`;
      try {
        const result = await getApi(endpoint);
        setCandidateData(result?.data?.data);
      } catch (e) {
        toast.error(recruitConstant.errorMsg);
        console.error("Error fetching job openings:", e);
      }
    };
    if (!isEmployee) {
      fetchCandidateData()
    }
  }, [isEmployee]);

  const handleNavigateToInterview = useCallback((values, mode = "overview") => {
    const app = values?.application;
    if (app && app.deleted === true) {
      setInfoModal({ isOpen: true, message: "This application has been deleted and cannot be viewed." });
      return;
    }
    if (!app) {
      setInfoModal({ isOpen: true, message: "This interview is not linked to a valid application." });
      return;
    }
    sessionStorage.setItem("mode", mode);
    navigate(`/recruitment/interview-create/${values?._id}`);
  }, [navigate]);
  const onLinkClick = (id) => {
    // sessionStorage.setItem("mode", "overview"); // Save mode in sessionStorage
    // navigate(`/recruitment/interview-create/${id}`);
  };
  const handleNavigateToJobOpening = useCallback((jobOpeningId, mode = "overview") => {
    if (!jobOpeningId) {
      setInfoModal({ isOpen: true, message: "Job opening information is not available." });
      return;
    }

    sessionStorage.setItem("mode", mode);
    navigate(`/recruitment/job-opening-create/${jobOpeningId}`);
  }, [navigate]);

  const canSelectRow = useCallback((rowData) => {
    const isCreator = rowData?.createBy?._id === loggedInUser?._id;

    return permission?.delete && (isSuperAdmin || isCreator);
  }, [loggedInUser?._id, permission?.delete, isSuperAdmin]);

  const actionHeader = {
    Header: recruitConstant.actions,
    isSortable: false,
    center: true,
    disableRowClick: true,
    cell: ({ row }) => {
      const isCreator = row?.original?.createBy?._id === loggedInUser?._id;
      const canDelete = permission?.delete && (isSuperAdmin || isCreator);
      const canEdit = permission?.update && (isSuperAdmin || isCreator);

      return (
        <ActionMenu
          canView={true}
          canEdit={canEdit}
          canDelete={canDelete}
          onView={() => {
            sessionStorage.setItem("mode", "overview");
            navigate(`/recruitment/interview-create/${row?.values?._id}`);
          }}
          onEdit={() => {
            sessionStorage.setItem("mode", "edit");
            navigate(`/recruitment/interview-create/${row?.values?._id}`);
          }}
          onDelete={() => {
            setDelete(true);
            setSelectedValues([row?.values?._id]);
          }}
        />
      );
    },
  };
  const tableColumns = useMemo(() => {
    return [
      {
        Header: "#",
        accessor: "_id",
        isSortable: false,
        width: 5,
      },
      {
        Header: recruitConstant.interviewId,
        accessor: "interviewId",
        cell: ({ row }) => {
          const interviewId = row.original?.interviewId;
          return (
            <Text
              as="span"
              cursor={interviewId ? "pointer" : "default"}
              fontWeight="400"
              color={interviewId ? colors.cta["100"] : "inherit"}
              _hover={interviewId ? { textDecoration: "underline", color: colors.cta["100"] } : undefined}
              onClick={interviewId ? () => {
                sessionStorage.setItem("mode", "overview");
                navigate(`/recruitment/interview-create/${row?.values?._id}`);
              } : undefined}
            >
              {interviewId || "-"}
            </Text>
          );
        },
      },
      {
        Header: recruitConstant.candidatesName,
        accessor: "candidatesName",
        cell: ({ row }) => {
          const candidateName = row.original?.application?.candidateDetails?.name || row.original?.candidateName;

          return <Text>{candidateName || "-"}</Text>;
        },
      },

      {
        Header: "Interview Round",
        accessor: "round",
        cell: ({ row }) => {

          const interviewDate = row?.original?.interviewDate

          return (
            <Box display={'flex'} flexDirection={'column'}>
              <Text width={"100px"} >
                {row.original?.round || "-"}
              </Text>
              <Text className="smallText">
                {interviewDate
                  ? new Date(interviewDate).toLocaleDateString("en-GB")
                  : "-"}
              </Text>
            </Box>
          )
        },
      },
      {
        Header: `${recruitConstant.interviewSlot}`,
        accessor: "timeRange",
        cell: ({ row }) => {
          const start = formatTime(row.original?.startTime);
          const end = formatTime(row.original?.endTime);

          return (
            <Text whiteSpace={'nowrap'}>
              {`${start} - ${end}`}
            </Text>
          );
        },
      },
      {
        Header: recruitConstant.status,
        accessor: "status",
        type: "text",
        formikType: "",
        cell: ({ row }) => {
          const statusValue = row.original?.interviewStatus;
          const matchedStatus = interviewStatusOptions.find(
            (option) => option.value === statusValue
          );

          const displayLabel = matchedStatus ? matchedStatus.label : statusValue || "";
          const statusColor = String(getStatusColor(statusValue)).replace(/\s*!important\s*/gi, "").trim();

          return <CustomStatus statusText={displayLabel} color={statusColor} />;
        },
      },
      {
        Header: recruitConstant.postingTitle,
        accessor: "postingTitle",
        cell: ({ row }) => {
          const jobTitle = row.original?.application?.job?.postingTitle || row.original?.jobTitle;
          const jobOpeningId = row.original?.application?.job?._id || row.original?.jobOpeningId;
          const formattedJobTitle = formatJobTitle(jobTitle);

          if (!formattedJobTitle) {
            return <Text>-</Text>;
          }

          const handleTitleClick = (e) => {
            e.stopPropagation();
            handleNavigateToJobOpening(jobOpeningId, "overview");
          };

          if (isEmployee) {
            return (
              <Box>
                <Text
                  as="span"
                  cursor={jobOpeningId ? "pointer" : "default"}
                  onClick={jobOpeningId ? handleTitleClick : undefined}
                  fontWeight="400"
                  color={jobOpeningId ? colors.cta["100"] : "inherit"}
                  _hover={jobOpeningId ? { textDecoration: "underline", color: colors.cta["100"] } : undefined}
                >
                  {formattedJobTitle}
                </Text>
              </Box>
            );
          }

          return (
            <Text
              as="span"
              cursor={jobOpeningId ? "pointer" : "default"}
              onClick={jobOpeningId ? handleTitleClick : undefined}
              fontWeight="400"
              color={jobOpeningId ? colors.cta["100"] : "inherit"}
              _hover={jobOpeningId ? { textDecoration: "underline", color: colors.cta["100"] } : undefined}
            >
              {formattedJobTitle}
            </Text>
          );
        },
      },
      {
        Header: "Panel",
        accessor: "interviewers",
        minWidth: 170,
        cell: ({ row }) => {
          const interviewers = row.original?.interviewers

          if (interviewers && interviewers.length > 0) {
            const interviewerNames = interviewers
              .map((interviewer) => {
                const panelName = interviewer?.panelName
                if (panelName) {
                  return `${panelName.firstName || ""} ${panelName.lastName || ""}`.trim()
                }
                return null
              })
              .filter((name) => name)

            if (!interviewerNames.length) {
              return <Text>-</Text>
            }

            const primaryInterviewer = interviewerNames[0]
            const remainingCount = interviewerNames.length - 1

            return (
              <Box minW="160px">
                <Text display="inline">{primaryInterviewer}</Text>
                {remainingCount > 0 && (
                  <Popover placement="bottom-start" trigger="click">
                    <PopoverTrigger>
                      <Text
                        as="button"
                        ml={2}
                        color={colors.cta["100"]}
                        fontWeight="600"
                        textDecoration="underline"
                      >
                        +{remainingCount}
                      </Text>
                    </PopoverTrigger>
                    <PopoverContent w="220px">
                      <PopoverBody>
                        <VStack align="start" spacing={1}>
                          {interviewerNames.map((name, index) => (
                            <Text key={`${name}-${index}`} fontSize="sm">
                              {name}
                            </Text>
                          ))}
                        </VStack>
                      </PopoverBody>
                    </PopoverContent>
                  </Popover>
                )}
              </Box>
            )
          }

          return (
            <Text>-</Text>
          )
        },
      },

      // {
      //   Header: recruitConstant.interviewDate,
      //   accessor: "interviewDate",
      //   cell: ({ row }) => (
      //     <Text cursor={"pointer"} onClick={() => {
      //       sessionStorage.setItem("mode", "overview");
      //       navigate(`/recruitment/interview-create/${row?.values?._id}`)
      //     }}>
      //       {row.original?.interviewDate
      //         ? new Date(row.original.interviewDate).toLocaleDateString("en-GB", {
      //           day: "2-digit",
      //           month: "2-digit",
      //           year: "numeric",
      //         })
      //         : "-"}
      //     </Text>
      //   ),
      // },
      ...(feedbackPermission.view ? [{
        Header: recruitConstant.feedback,
        disableRowClick: true,
        cell: ({ row }) => {
          const status = row?.original?.interviewStatus;
          const endTime = row?.original?.endTime ? new Date(row?.original?.endTime) : null;
          const now = new Date();

          const isView =
            status === "feedback_submitted"


          const isSubmit =
            status === "scheduled" && endTime && now > endTime;


          const interviewId = row?.original?._id;

          const handleClick = async (e) => {
            e.stopPropagation();

            // Submit Feedback → direct navigate with interview ID
            if (!isView) {
              navigate(`/recruitment/feedback-create/${interviewId}`, {
                state: { viewMode: false },
              });
              return;
            }

            // View Feedback → fetch feedback by interview ID, then navigate
            try {
              const res = await getApi(`api/recruitment/feedback?interview=${interviewId}`);

              const feedbackArray = res?.data?.data;

              if (!Array.isArray(feedbackArray) || feedbackArray.length === 0) {
                toast.error("Feedback not found");
                return;
              }

              const feedbackId = feedbackArray[0]._id;

              navigate(`/recruitment/feedback-create/${feedbackId}`, {
                state: { viewMode: true },
              });

            } catch (err) {
              toast.error("Feedback not found");
            }
          };

          const showView = isView;
          const showSubmit = status === 'completed' && (isEmployee || isSuperAdmin);
          const showPending = status === 'completed' && !isView;

          if (!showView && !showSubmit && !showPending) return null;

          // Show "Feedback Pending" button (disabled) for completed interviews without feedback
          if (showPending && !showSubmit) {
            return (
              <Button
                variant="outline"
                colorScheme="gray"
                mt={{ sm: "5px", md: "0" }}
                size="sm"
                isDisabled
                cursor="not-allowed"
              >
                Pending
              </Button>
            );
          }

          return (
            <Button
              variant="outline"
              className="advance-search-button"
              colorScheme="brand"
              mt={{ sm: "5px", md: "0" }}
              size="sm"
              onClick={handleClick}
            >
              {showView
                ? recruitConstant.view
                : recruitConstant.submit}
            </Button>
          );
        },
      }] : [])





      ,
      ...(permission?.update || permission?.delete ? [actionHeader] : []),
    ]
  }, [actionHeader, permission, navigate, feedbackPermission, isEmployee, isSuperAdmin, handleNavigateToJobOpening])

  const fetchData = async (
    page = currentPage,
    limit = pageSize,
    sortKey = sortColumn,
    order = sortOrder,
    searchTerm = "",
    fetchAllData = false,
    status = "",
    urlParams = {},
  ) => {
    setIsLoading(true)


    let endpoint = customApiEndpoint
      ? `${customApiEndpoint}?page=${page}&limit=${limit}`
      : `api/recruitment/interviews/?page=${page}&limit=${limit}`

    if (fetchAllData) {
      endpoint = customApiEndpoint ? `${customApiEndpoint}?allData=true` : `api/recruitment/interviews/?allData=true`
    }

    if (sortKey) {
      const sortParam = order === "desc" ? `-${sortKey}` : sortKey
      endpoint += `&sort=${sortParam}`
    }

    if (searchTerm) {
      endpoint += `&search=${encodeURIComponent(searchTerm)}`
    }

    if (status && status.trim() !== "") {
      // Normalize status to lowercase for consistency with backend
      const normalizedStatus = status.toLowerCase().trim();
      endpoint += `&status=${encodeURIComponent(normalizedStatus)}`
    }

    // Add URL parameters to the API call
    Object.keys(urlParams).forEach((key) => {
      if (urlParams[key]) {
        endpoint += `&${key}=${encodeURIComponent(urlParams[key])}`
      }
    })

    try {
      const result = await getApi(endpoint)
      if (fetchAllData) {
        setFinalSearchedData(result?.data?.data)
      } else {
        setData(result?.data?.data || [])
        setMetadata(result?.data?.metadata)
      }
    } catch (e) {
      toast.error(recruitConstant.errorMsg)
      console.error("Error fetching interviews:", e)
    } finally {
      setIsLoading(false)
    }
  }

  // Handler for status filter change
  const handleStatusFilterChange = useCallback(
    (selectedStatus) => {
      // Map common label variations to values
      const statusMap = {
        'in progress': 'in_progress',
        'In Progress': 'in_progress',
        'completed': 'completed',
        'Completed': 'completed',
        'scheduled': 'scheduled',
        'Scheduled': 'scheduled',
      };
      const normalizedStatus = statusMap[selectedStatus] || selectedStatus;
      // Update current status filter state
      setCurrentStatusFilter(normalizedStatus);
      setCurrentPage(1);
    },
    []
  );

  // Fetch data when filters or pageSize change
  useEffect(() => {
    const getUrlParams = () => {
      let currentInterviewDate = searchParams.get("interviewDate");
      let currentDateFilter = searchParams.get("dateFilter");
      let currentStartDate = searchParams.get("startDate");
      let currentEndDate = searchParams.get("endDate");

      if (window.location.hash) {
        const hashParts = window.location.hash.split("?");
        if (hashParts.length > 1) {
          const hashParams = new URLSearchParams(hashParts[1]);
          currentInterviewDate = currentInterviewDate || hashParams.get("interviewDate");
          currentDateFilter = currentDateFilter || hashParams.get("dateFilter");
          currentStartDate = currentStartDate || hashParams.get("startDate");
          currentEndDate = currentEndDate || hashParams.get("endDate");
        }
      }

      const urlParams = {};
      if (currentInterviewDate) urlParams.interviewDate = currentInterviewDate;
      if (currentDateFilter) urlParams.dateFilter = currentDateFilter;
      if (currentStartDate) urlParams.startDate = currentStartDate;
      if (currentEndDate) urlParams.endDate = currentEndDate;
      return urlParams;
    };

    const urlParams = getUrlParams();

    // When filters change, reset to page 1 and fetch
    fetchData(
      1, // Always start from page 1 when filters change
      pageSize,
      sortColumn,
      sortOrder,
      searchbox || "",
      false,
      currentStatusFilter || "",
      urlParams
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    location.search, // URL params change (for regular routing)
    location.hash, // Hash routing params change
    pageSize, // Page size change
    customApiEndpoint, // Endpoint change
    currentStatusFilter, // Status filter change
    sortColumn, // Sort column change
    sortOrder, // Sort order change
    searchParams, // Search params change
  ]);

  const handleSearchChange = (term) => {
    const trimmedTerm = term?.trim() || "";
    setSearchbox(trimmedTerm);

    const pageToFetch = trimmedTerm === "" ? currentPage : 1
    const urlParams = {};
    if (urlInterviewDate) {
      urlParams.interviewDate = urlInterviewDate;
    }
    if (searchParams.get("dateFilter")) urlParams.dateFilter = searchParams.get("dateFilter");
    if (searchParams.get("startDate")) urlParams.startDate = searchParams.get("startDate");
    if (searchParams.get("endDate")) urlParams.endDate = searchParams.get("endDate");
    if (trimmedTerm !== "" && currentPage !== 1) {
      setCurrentPage(1);
    }
    fetchData(pageToFetch, pageSize, sortColumn, sortOrder, trimmedTerm, false, currentStatusFilter || "", urlParams)
  }

  const handleSortChange = (accessorKey) => {
    let newSortOrder = "asc"

    if (sortColumn === accessorKey) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc"
    }

    setSortColumn(accessorKey)
    setSortOrder(newSortOrder)

    const urlParams = {};
    if (urlInterviewDate) {
      urlParams.interviewDate = urlInterviewDate;
    }
    if (searchParams.get("dateFilter")) urlParams.dateFilter = searchParams.get("dateFilter");
    if (searchParams.get("startDate")) urlParams.startDate = searchParams.get("startDate");
    if (searchParams.get("endDate")) urlParams.endDate = searchParams.get("endDate");
    fetchData(currentPage, pageSize, accessorKey, newSortOrder, searchbox, false, currentStatusFilter || "", urlParams)
  }


  // "api/recruitment/interview/deleteMany"

  const handleDeleteInterview = async (ids) => {
    try {
      setDelete(false)
      const response = await deleteManyApi("api/recruitment/interviews/deleteMany", ids)
      if (response.status === 200) {
        setSelectedValues([])
        const urlParams = {};
        if (urlInterviewDate) {
          urlParams.interviewDate = urlInterviewDate;
        }
        if (searchParams.get("dateFilter")) urlParams.dateFilter = searchParams.get("dateFilter");
        if (searchParams.get("startDate")) urlParams.startDate = searchParams.get("startDate");
        if (searchParams.get("endDate")) urlParams.endDate = searchParams.get("endDate");
        fetchData(currentPage, pageSize, sortColumn, sortOrder, searchbox, false, currentStatusFilter || "", urlParams)
        toast.success(
          `${menuSelectedDeleteItem.length > 0
            ? constant.interview
            : selectedValues && selectedValues.length > 1
              ? `${constant.interview}s`
              : constant.interview
          } ${constant.deletedSuccessfully}`,
        )
        setAction((pre) => !pre)
      }
    } catch (error) {
      toast.error("Something went wrong")
    } finally {
      setMenuSelectedDeleteItem([])
    }
  }

  const [selectedColumns, setSelectedColumns] = useState([...tableColumns])
  useEffect(() => {
    if (isInitialMount.current && tableColumns.length > 0) {
      setSelectedColumns([...tableColumns]);
      isInitialMount.current = false;
    }
  }, [tableColumns]);

  // Memoize dataColumn
  const dataColumn = useMemo(() =>
    tableColumns?.filter((item) =>
      selectedColumns?.find((colum) => colum?.accessor === item.accessor)
    ),
    [tableColumns, selectedColumns]
  );

  function closeDeleteModal() {
    setMenuSelectedDeleteItem([])
    setDelete(false)
  }

  return (
    <div className={customApiEndpoint ? 'detailPageTable' : ''}>
      <CommonCheckTable
        title={title}
        showInlineTitle={true}
        inlineTitle={
          isEmployee
            ? `My Interviews (${metadata?.totalRecords ?? data?.length ?? 0})`
            : `Interviews (${metadata?.totalRecords ?? data?.length ?? 0})`
        }
        isLoading={isLoading}
        columnData={tableColumns}
        dataColumn={dataColumn}
        allData={data}
        tableData={data}
        setSearchDisplay={setDisplaySearchData}
        tableCustomFields={[]}
        access={permission}
        action={action}
        setAction={setAction}
        checkBox={canSelectRow}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        isOpen={isOpen}
        onClose={onclose}
        onOpen={onOpen}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        setDelete={setDelete}
        fetchData={fetchData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        isHideNavbarAction={!customApiEndpoint}
        // AdvanceSearch={
        //   <Button
        //     variant="outline"
        //     className="advance-search-button"
        //     colorScheme="brand"
        //     leftIcon={<SearchIcon />}
        //     mt={{ sm: "5px", md: "0" }}
        //     size="sm"
        //     onClick={() => setAdvanceSearch(true)}
        //   >
        //     {constant.advanceSearch}
        //   </Button>
        // }
        // getTagValuesOutSide={getTagValuesOutSide}
        searchboxOutside={searchboxOutside}
        sortOrder={sortOrder}
        searchbox={searchbox}
        setSearchbox={setSearchbox}
        setSearchboxOutside={setSearchboxOutside}
        finalSearchedData={finalSearchedData}
        setFinalSearchedData={setFinalSearchedData}
        metadata={metadata}
        handleSortChange={handleSortChange}
        handleSearchChange={handleSearchChange}
        onLinkClick={onLinkClick}
        filterStatusOptions={interviewStatusOptions}
        statusFilter={true}
        handleStatusFilterChange={handleStatusFilterChange}
        currentStatusFilter={currentStatusFilter}
        isDynamic={true}
      />

      <CommonDeleteModel
        isOpen={deleteModel}
        onClose={() => closeDeleteModal()}
        type={
          menuSelectedDeleteItem.length > 0
            ? constant.interview
            : selectedValues && selectedValues.length > 1
              ? `${constant.interview}s`
              : constant.interview
        }
        handleDeleteData={handleDeleteInterview}
        ids={selectedValues}
        onCancel={() => setSelectedValues([])}
      />

      <InfoModal
        isOpen={infoModal.isOpen}
        onClose={() => setInfoModal({ isOpen: false, message: "" })}
        message={infoModal.message}
      />

      <PreviousApplicationInterviewModal
        isOpen={previousInterviewModal.isOpen}
        onClose={() => setPreviousInterviewModal({
          isOpen: false,
          applicationId: null,
          candidateName: '',
          jobTitle: '',
          currentInterviewId: null,
          currentInterviewDate: null,
          currentRound: null
        })}
        applicationId={previousInterviewModal.applicationId}
        candidateName={previousInterviewModal.candidateName}
        jobTitle={previousInterviewModal.jobTitle}
        currentInterviewId={previousInterviewModal.currentInterviewId}
        currentInterviewDate={previousInterviewModal.currentInterviewDate}
        currentRound={previousInterviewModal.currentRound}
        hasPermission={permission?.view || isSuperAdmin}
      />

    </div>
  )
}

export default Interview
